import type * as React from 'react';
import type { intlShape } from 'react-intl';
import { injectIntl } from 'react-intl';
import { key } from '../messages';

export interface IExternalLayoutProps {
	body: React.ReactElement<any>;
	intl: intlShape;
}

function ExternalLayout(props: IExternalLayoutProps) {
	const { intl } = props;

	const copyrightMessage = intl.formatMessage({
		id: key((x) => x.copyrightMessages.copyright),
	});
	const confidentialityNotice = intl.formatMessage({
		id: key((msg) => msg.copyrightMessages.confidentialityNotice),
	});
	const termsOfUse = intl.formatMessage({
		id: key((msg) => msg.privacyMessages.termsOfUse),
	});
	const privacyPolicy = intl.formatMessage({
		id: key((msg) => msg.privacyMessages.privacyPolicy),
	});
	const cookiePolicy = intl.formatMessage({
		id: key((msg) => msg.privacyMessages.cookiePolicy),
	});
	const californiaCollectionNotice = intl.formatMessage({
		id: key((msg) => msg.privacyMessages.californiaCollectionNotice),
	});
	const privacyChoices = intl.formatMessage({
		id: key((msg) => msg.privacyMessages.privacyChoices),
	});

	const copyright = (
		<p className="text-muted">
			{copyrightMessage} <b>{confidentialityNotice}</b>
		</p>
	);
	const terms = (
		<a
			href="https://www.directsupply.com/legal/terms-of-use/"
			rel="noreferrer"
			target="_blank"
		>
			{termsOfUse}
		</a>
	);
	const privacy = (
		<a
			href="https://www.directsupply.com/legal/privacy-policy"
			rel="noreferrer"
			target="_blank"
		>
			{privacyPolicy}
		</a>
	);
	const cookie = (
		<a
			href="https://www.directsupply.com/legal/cookie-policy"
			rel="noreferrer"
			target="_blank"
		>
			{cookiePolicy}
		</a>
	);
	const californiaCollection = (
		<a
			href="https://www.directsupply.com/legal/privacy-policy#california-collection-notice"
			rel="noreferrer"
			target="_blank"
		>
			{californiaCollectionNotice}
		</a>
	);
	const privacyChoice = (
		<a href="#" onClick={() => (window as any).OneTrust.ToggleInfoDisplay()}>
			{privacyChoices}
			{'     '}
			<img
				src="/images/opt-out.png"
				style={{ height: '1em', display: 'inline' }}
			/>
		</a>
	);
	const divider = '     \u2022     ';
	const privacyLine = (
		<p className="text-muted">
			{terms}
			{divider}
			{privacy}
			{divider}
			{cookie}
			{divider}
			{californiaCollection}
			{divider}
			{privacyChoice}
		</p>
	);
	return (
		<div className="wrapper">
			<div className="main container-fluid">
				<div className="container">
					{props.body}
					<div className="push" />
				</div>
			</div>
			<footer className="footer">
				<div className="container text-center-xs">{copyright}</div>
				<div className="container text-center-xs">{privacyLine}</div>
			</footer>
		</div>
	);
}

export default injectIntl(ExternalLayout);
